/** Mirror the position for RTL */
export const getRTLPosition = (position) => {
    if (position.includes("start"))
        return position.replace("start", "end");
    if (position.includes("end"))
        return position.replace("end", "start");
    return position;
};
/**
 * Get a position value which centers 2 elements vertically or horizontally
 */
export const centerBySize = (originSize, targetSize) => {
    return Math.floor(originSize / 2 - targetSize / 2);
};
